import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-folder',
  templateUrl: './folder.component.html',
  styleUrls: ['./folder.component.css']
})
export class FolderComponent implements OnInit {

  constructor(private folderService:ServiceService,private route: ActivatedRoute, private router: Router) { }
  CreateFolderShown=false;
  FName="*";
  output:any=[];
  next_output:any=[];
  prv_output:any=[];
  output1:any=[];
  parent:any=[];
  folders:any=[];
  SingleFolder:any=[];
  deleteFolderName="";
  deleteFolderId="";
  msg1=""
  loaderShown=true;
  cardShown=false;
  EditFolderName="";
  count=0;
  Addsub=false
  New_count=0;
  SubName="*"
  data={
    folder_code:"",
    folder_name:"",
    parent_folder_id:null,
    parent_folder_code:"",
    parent_folder_name:"",
    // relative_folder_id:"",
    // relative_folder_code:"",
    // relative_folder_name:""
    relative_folder:Array()
  }

  sub_data={
    shansapp_folder_id:"",
    sub_folder_name:""

  }

  selectedItems:any = [];
  dropdownList:any = [];

  dropdownSettings = {
    singleSelection: false,
    idField: 'item_id',
    textField: 'item_text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    allowSearchFilter: true
  };
  
  //---function show sub folder card
  /*
  AddNewSub(){
    this.Addsub=true;
    this.CreateFolderShown=false
    this.sub_data.shansapp_folder_id=this.folders[0]._id;
    this.sub_data.sub_folder_name=""
  }
  
  //----function for create sub folder
  AddSubFolder(){
    if(this.sub_data.sub_folder_name==""){
      this.SubName="Enter a  folder name";
      return;
    }
    else{
      console.log("sub data=",this.sub_data)

      this.folderService.CreateSubFolder(this.sub_data).subscribe((res)=>{
        console.log(res)
        
       if(res.sucess=='false'){
        this.SubName=res.message;
       }
       else{
        this.Addsub=!this.Addsub;
        this.ngOnInit();
       }
      })

    }

  }
  */
  //---function for select folder name-------
  SelectFolder(value:any){
    this.folderService.GetFolderEach(value).subscribe((res)=>{
      this.SingleFolder=res.data
  

     this.data.parent_folder_id=this.SingleFolder[0]._id;
     this.data.parent_folder_code=this.SingleFolder[0].folder_code;
     this.data.parent_folder_name=this.SingleFolder[0].folder_name;  
    })
  }

  valuechange2(value:any){

  }
  CreateFolder(){
    this.data.folder_name="";
  this.CreateFolderShown=!this.CreateFolderShown
  
  // this.data.relative_folder_id=this.folders[0].folder_id;
  // this.data.relative_folder_code=this.folders[0].folder_code;
  // this.data.relative_folder_name=this.folders[0].folder_name;


  this.Addsub=false;
  }
  setRelatedFolder(){

    this.data.relative_folder=[];
    for(var i=0;i<this.selectedItems.length;i++){
      var obj={
        product_folder_id:this.selectedItems[i].item_id,
        product_folder_name:this.selectedItems[i].item_text
      }
      this.data.relative_folder.push(obj)
    }
    this.data.folder_code=this.data.folder_name
  }
  AddFolder(){

    this.setRelatedFolder();
    console.log("Selected item=",this.data)
   // return
    if(this.data.folder_name==""){
      this.FName="Enter a folder name";
      return;
    }
 
    else{
      console.log("data=",this.data);
      this.folderService.CreateFolder(this.data).subscribe((res)=>{
        console.log(res)
        
       if(res.sucess=='false'){
        this.FName=res.message;
       }
       else{
        this.CreateFolderShown=!this.CreateFolderShown;
        this.ngOnInit();
        this.selectedItems=[]
       }
      })
    
    }

  }
  SetFolderId(Id:any,Name:any){
    this.deleteFolderId=Id;
    this.deleteFolderName=Name;
  }
//------function for delete selected folder----------
DeleteFolder(){
  this.folderService.DeleteFolder(this.deleteFolderId).subscribe((res)=>{
   this.ngOnInit();
  })

}
//---------check value changes in the text box----
valuechange1(newValue1: any) {
  this.data.folder_name=newValue1
  this.FName="*"
}
//---------check value changes in the text box sub name----
/*
valuechange2(newValue1: any) {
  this.data.rel_folder_id=newValue1
  this.SubName="*"
}
*/
//-----function for edit folder name set---------
EditFolderSet(Id:any){
 // this.Edit_data.folder_name=""
 // this.EditFolderName=Name;
 // this.Edit_data._id=Id
 this.router.navigate(['/admin/edit-folder']);
 this.folderService.SetFolderId(Id);
 document.body.scrollTop = document.documentElement.scrollTop = 0;
}

//---function for click previous----------
clicks_previous(){
  if(this.New_count==0){
    return;
  }
  else{
    this.New_count=this.New_count-1;
    this.count=this.New_count; 
  }
  this.folderService.GetFolder(this.count).subscribe((res)=>{
    this.output=res.data
  })

}
//-------function for click next-------
clicks_next(){
  this.count=this.count+1
  this.folderService.GetFolder(this.count).subscribe((res)=>{
    this.next_output=res.data
    if(this.next_output.length!=0){
      this.output=this.next_output;
      this.New_count=this.count;
    }
  })


}

onItemSelect(item: any) {
  // console.log(item);
  // console.log("one Item selected",this.selectedItems);
  // this.SetQuotationDetails1()
  // this.msg1=""
}
onSelectAll(items: any) {
  // console.log(items);
  this.selectedItems=items
  // console.log("All Item selected",this.selectedItems);
  // this.SetQuotationDetails1()
  // this.msg1=""
}
onDeSelect(item:any){
  // console.log(item);
  // console.log("Item De selected",this.selectedItems);
  // this.SetQuotationDetails1()
}
onDeSelecAll(){
  console.log("hai")
  //this.IDandSize=[];
}

  ngOnInit(): void {

    this.loaderShown=true;
    this.cardShown=false;
    /*
    this.count=0;
    this.New_count=0;
*/
    this.folderService.GetFolder(this.count).subscribe((res)=>{
      this.output=res.data

      this.loaderShown=false;
      this.cardShown=true;
    })

    this.folderService.GetFolderDropdown().subscribe((res)=>{
      this.parent=res.data
    })
    //----api for folder drop down-----
    this.folderService.GetProductFolder().subscribe((res)=>{
      this.folders=res.data
      console.log("folders=",this.folders)

      for(var i=0;i<res.data.length;i++){
        this.dropdownList.push({ item_id: res.data[i].folder_id, item_text: res.data[i].folder_name});
      }
     
    })
  }

}
